<template>
  <div v-if="isWixinOpen" class="hint">请点击右上角...选择在浏览器中打开。</div>
  <div v-else class="content">
    <!-- 登录 -->
    <div class="login_bgc" v-if="type==1">
      <div class="title">欢迎登录</div>
      <input type="text" v-model="name" class="name" />
      <span class="name_label label">姓 &nbsp;&nbsp;&nbsp; 名:</span>
      <span class="pswd_label label">密 &nbsp;&nbsp;&nbsp; 码:</span>
      <input type="password" v-model="pswd" class="pswd" />
      <img src="../assets/images/login_btn.png" class="login_btn" alt @click="login" />
      <img src="../assets/images/register.png" class="register_btn" alt @click="type='4'" />
      <span href="javaScript:0;" class="forget" @click="type='2'">忘记密码？</span>
      <span href="javaScript:0;" class="code_login" @click="type='3'">验证码登录</span>
    </div>
    <!-- 忘记密码 -->
    <div class="login_bgc" v-if="type==2">
      <div class="title">重置密码</div>
      <input type="text" v-model="mobile" class="mobile" />
      <input type="text" v-model="code" class="code" />
      <input type="password" v-model="newpswd" class="newpswd" />
      <input type="password" v-model="confirgpswd" class="confirgpswd" />
      <span class="mobile_label label">手机号:</span>
      <span class="code_label label">验证码:</span>
      <span class="get_code_label">
        <span v-if="show60s">{{times+'s'}}</span>
        <span v-else @click="getEditCode">获取验证码</span>
      </span>
      <span class="newpswd_label label">新密码:</span>
      <span class="confirgpswd_label label">确定密码:</span>
      <img src="../assets/images/confirg.png" class="login_btn" alt @click="confirg" />
    </div>
    <!-- 验证码 -->
    <div class="login_bgc" v-if="type==3">
      <div class="title">欢迎登录</div>
      <input type="text" v-model="mobile" class="mobile" />
      <span class="mobile_label label">手机号:</span>
      <input type="text" v-model="code" class="code" />
      <span class="code_label label">验证码:</span>
      <span class="get_code_label">
        <span v-if="show60s">{{times+'s'}}</span>
        <span v-else @click="getLoginCode">获取验证码</span>
      </span>
      <img src="../assets/images/login_btn.png" class="login_btn" alt @click="code_login" />
      <span href="javaScript:0;" class="code_login" @click="type='1'">密码登录</span>
    </div>
    <!-- 注册 -->
    <div class="register_bgc" v-if="type==4">
      <img src="../assets/images/close.png" class="back" alt @click="backLogin" />
      <div class="title">欢迎注册</div>
      <input type="text" v-model="mobile" class="register_mobile" />
      <input type="text" v-model="code" class="register_code" />
      <input type="password" v-model="pswd" class="register_pswd" />
      <input type="text" v-model="name" class="register_name" />
      <input type="text" v-model="school" class="register_school" />
      <!-- <select name="register_school" id="" class="register_school" v-model="school_val">
          <option v-for="item in school" :key="item.id" :value="item.id">{{item.school_name}}</option>
      </select>-->
      <!-- <input type="text" v-model="name" class="register_grade"> -->
      <select name="register_grade" id class="register_grade" v-model="grade_val">
        <option v-for="item in grade" :key="item.id" :value="item.id">{{item.grade_name}}</option>
      </select>
      <span class="register_name_label label">姓名:</span>
      <span class="register_school_label label">学校:</span>
      <span class="register_grade_label label">年级:</span>
      <span class="register_mobile_label label">手机号:</span>
      <span class="register_code_label label">验证码:</span>
      <span class="register_get_code_label">
        <span v-if="show60s">{{times+'s'}}</span>
        <span v-else @click="getCode">获取验证码</span>
      </span>
      <span class="register_pswd_label label">密码:</span>
      <img src="../assets/images/tijiao.png" class="submit_btn" alt @click="register" />
    </div>
    <!-- 完善信息 -->
    <div class="login_bgc" v-if="type==5">
      <div class="title">完善信息</div>
      <div class="header_box">
        <!--  -->
        <div class="header">
          <img v-show="info" :src="info.headimgurl" class="header_img" alt />
        </div>
        <img src="../assets/images/upload.png" alt @click="show_shade=true" class="upload" />
      </div>
      <input type="text" class="birthday" />
      <span class="birthday_label label">生 &nbsp;&nbsp;&nbsp; 日:</span>
      <span class="gender_label label">性 &nbsp;&nbsp;&nbsp; 别:</span>
      <select name="gender" id class="gender" v-model="gender">
        <option value="1">男</option>
        <option value="0">女</option>
      </select>
      <el-date-picker
        v-model="birthday"
        type="date"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        placeholder="选择日期"
      ></el-date-picker>
      <!-- <input type="text" v-model="gender" class="gender"> -->
      <img src="../assets/images/tijiao.png" class="tijiao_btn" alt @click="gologin" />
    </div>
    <div class="shade" v-if="show_shade">
      <div class="header_list">
        <ul>
          <li v-for="(item,index) in headers" :key="index">
            <div class="system_box">
              <img
                :src="item.img_url"
                alt
                class="system_header"
                @click="select_header(index,item.img_path)"
                :class="{'select_show' :show_select==index}"
              />
              <img
                src="../assets/images/select_header.png"
                alt
                class="selecet_header"
                v-if="show_select==index"
              />
            </div>
          </li>
        </ul>
        <img src="../assets/images/queding.png" class="queding" alt @click="change_header" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      //类型
      type: "1",
      //登录账号密码
      // name:'小王',
      name: "",
      // pswd:'a123456',
      pswd: "",
      //生日
      birthday: "",
      //性别
      gender: "",
      //修改密码
      mobile: "",
      code: "",
      newpswd: "",
      confirgpswd: "",
      //注册
      school_val: "",
      school: "",
      grade_val: "",
      //显示倒计时
      show60s: false,
      times: 60,
      //学校列表
      // schoolList:[],
      //班级列表
      grade: [],
      //头像
      headerurl: "",
      //遮罩层
      show_shade: false,
      //系统头像
      headers: [],
      show_select: null,
      //注册完成之后获取个人信息
      info: "",
      //是否微信浏览器打开
      isWixinOpen: false
    };
  },
  created() {
    this.isWeiXin();
    //判断是否登录
    this.is_Login();
    // this.getschool();
    this.getgrade();
    this.getheader();
  },
  methods: {
    //判断是否是微信浏览器的函数
    isWeiXin() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase();
      // alert(JSON.stringify(ua))
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.$router.replace("/hint");
        this.isWixinOpen = true;
        return;
      } else {
        return;
      }
    },
    is_Login() {
      var token = window.sessionStorage.getItem("token");
      if (token) {
        this.$router.push({
          name: "newHome"
        });
      }
    },
    //获取验证码
    getCode() {
      if (!this.mobile) {
        this.$msg.warning("请输入手机号");
        return;
      }
      var data = {
        mobile: this.mobile
      };
      this.$axios.post("/api/v1/register/sendcode", data).then(res => {
        this.$msg.success(res.data.message);
        this.getCode_count_down();
      });
    },
    //获取验证码
    getLoginCode() {
      if (!this.mobile) {
        this.$msg.warning("请输入手机号");
        return;
      }
      var data = {
        mobile: this.mobile
      };
      this.$axios.post("/api/v1/login/sendcode", data).then(res => {
        this.$msg.success(res.data.message);
        this.getCode_count_down();
      });
    },
    //获取验证码
    getEditCode() {
      if (!this.mobile) {
        this.$msg.warning("请输入手机号");
        return;
      }
      var data = {
        mobile: this.mobile
      };
      this.$axios.post("/api/v1/pwd/sendcode", data).then(res => {
        this.$msg.success(res.data.message);
        this.getCode_count_down();
      });
    },
    getCode_count_down() {
      this.show60s = true;
      this.timer = setInterval(() => {
        this.times--;
        if (this.times === 0) {
          this.show60s = false;
          clearInterval(this.timer);
          this.times = 60;
        }
      }, 1000);
    },
    //登录
    login() {
      if (!this.name || !this.pswd) {
        this.$msg.warning("请输入姓名密码");
        return;
      }
      // var data=
      this.$axios
        .post("/api/v1/login/bypwd", {
          username: this.name,
          password: this.pswd
        })
        .then(res => {
          if (res.data.result_code == 200) {
            this.$msg.success(res.data.message);
            window.sessionStorage.setItem("token", res.data.data.token);
            this.$router.push({
              name: "newHome"
              // query: {
              //   alert: res.data.data.alert_msg ? res.data.data.alert_msg : ""
              // }
            });
            if (res.data.data.alert_msg) {
              window.localStorage.setItem(
                "alert_msg",
                JSON.stringify(res.data.data.alert_msg)
              );
            }
          } else {
            this.$msg.error(res.data.message);
          }
          // console.log(res);
        });
    },
    //验证码登录
    code_login() {
      if (!this.mobile || !this.code) {
        this.$msg.warning("请输入手机号获取验证码");
        return;
      }
      var data = {
        mobile: this.mobile,
        validate_code: this.code
      };
      this.$axios.post("/api/v1/login/bymobile", data).then(res => {
        if (res.data.result_code == 200) {
          this.$msg.success(res.data.message);
          window.sessionStorage.setItem("token", res.data.data.token);
          this.$router.push({
            name: "newHome",
            query: {
              alert: res.data.data.alert_msg ? res.data.data.alert_msg : ""
            }
          });
        } else {
          this.$msg.error(res.data.message);
        }
      });
    },
    //重置密码
    confirg() {
      if (!this.mobile || !this.code || !this.newpswd || !this.confirgpswd) {
        this.$msg.warning("请输入以上信息");
        return;
      }
      if (this.newpswd !== this.confirgpswd) {
        this.$msg.warning("两次密码不一致");
        return;
      }
      this.$axios
        .post("/api/v1/pwd/editpwd", {
          mobile: this.mobile,
          validate_code: this.code,
          password: this.newpswd,
          repassword: this.confirgpswd
        })
        .then(res => {
          if (res.data.result_code == 200) {
            this.$msg.success(res.data.message);
            this.type = "1";
          } else {
            this.$msg.error(res.data.message);
          }
        });
    },
    //获取学校，班级下拉数据
    // getschool(){
    //   this.$axios.get(
    //     '/api/v1/getschools',
    //   ).then(res=>{
    //     // console.log(res.data.data);
    //     this.school=res.data.data
    //   })
    // },
    getgrade() {
      this.$axios.get("/api/v1/getgrades").then(res => {
        // console.log(res.data.data);
        this.grade = res.data.data;
      });
    },
    //注册
    register() {
      if (
        !this.name ||
        !this.mobile ||
        !this.grade_val ||
        !this.code ||
        !this.pswd
      ) {
        this.$msg.warning("请输入以上信息");
        return;
      }
      var data = {
        username: this.name,
        mobile: this.mobile,
        validate_code: this.code,
        school: this.school,
        grade: this.grade_val,
        password: this.pswd
      };
      this.$axios.post("/api/v1/register/do", data).then(res => {
        if (res.data.result_code == 200) {
          window.sessionStorage.setItem("token", res.data.data.token);
          this.getinfo();
          this.$msg.success(res.data.message);
          this.type = "5";
        } else {
          this.$msg.error(res.data.message);
        }
      });
    },
    //回到登录
    backLogin() {
      this.type = "1";
    },
    //完善信息去登陆
    gologin() {
      if (!this.birthday || !this.gender) {
        this.$msg.warning("请输入生日或性别");
        return;
      }
      this.$axios
        .post("/api/v1/user/editinfo", {
          birthday: this.birthday,
          sex: this.gender
        })
        .then(res => {
          if (res.data.result_code == 200) {
            this.$msg.success(res.data.message);
            this.type = "1";
          } else {
            this.$msg.error(res.data.message);
          }
        });
    },
    //获取系统头像
    getheader() {
      this.$axios.get("/api/v1/getheadimg").then(res => {
        // console.log(res);
        this.headers = res.data.data;
      });
    },
    //获取个人信息
    getinfo() {
      this.$axios.get("/api/v1/user/info").then(res => {
        this.info = res.data.data;
      });
    },
    //选择头像
    select_header(num, url) {
      if (this.show_select == num) return;
      this.show_select = num;
      this.headerurl = url;
    },
    //更换头像
    change_header() {
      this.$axios
        .post("/api/v1/user/editinfo", {
          headimgurl: this.headerurl
        })
        .then(res => {
          // console.log(res);
          if (res.data.result_code == 200) {
            this.$msg.success(res.data.message);
            this.show_shade = false;
            this.getinfo();
          } else {
            this.$msg.error(res.data.message);
          }
        });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.back {
  width: 0.65rem;
  height: 0.65rem;
  position: absolute;
  top: -0.1rem;
  right: -0.1rem;
}

.hint {
  width: 100%;
  height: 1rem;
  text-align: center;
  line-height: 1rem;
  font-size: 1rem;
  font-family: "Normal";
  position: absolute;
  top: 40%;
  left: 0;
  transform: translate(0, -40%);
}
.submit_btn {
  width: 1.36rem;
  height: 0.41rem;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
}
::-webkit-scrollbar {
  width: 0.133333rem;
  height: 0.05rem;
}
.login_bgc {
  width: 5.2rem;
  height: 3.39rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: url("../assets/images/login_bgc.png") no-repeat;
  background-size: 100% 100%;
}
.login_btn {
  width: 1.36rem;
  height: 0.41rem;
  position: absolute;
  bottom: -0.09rem;
  right: 0.66rem;
  cursor: pointer;
}
.register_btn {
  width: 1.36rem;
  height: 0.41rem;
  position: absolute;
  bottom: -0.09rem;
  left: 0.66rem;
  cursor: pointer;
}
.title {
  width: 1.16rem;
  height: 0.26rem;
  line-height: 0.26rem;
  position: absolute;
  top: -0.08rem;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 0.26rem;
  color: #5c2a19;
  font-family: "Medium";
  font-weight: bold;
}
input {
  width: 2.91rem;
  height: 0.4rem;
  background-color: #bf6004;
  border-radius: 0.2rem;
  border: none !important;
  font-size: 0.17rem;
  font-family: "Normal";
  color: #fff;
  box-sizing: border-box;
  padding-left: 0.86rem;
  line-height: 0.4rem;
}
select {
  width: 2.91rem;
  height: 0.4rem;
  background-color: #bf6004;
  border-radius: 0.2rem;
  border: none !important;
  font-size: 0.17rem;
  font-family: "Normal";
  color: #fff;
  box-sizing: border-box;
  padding-left: 0.86rem;
  appearance: none;
}
select:focus-visible {
  outline: none;
}

.name {
  position: absolute;
  top: 0.71rem;
  left: 1.11rem;
}
.name_label {
  /* font-family: 'gdh' !important; */
  /* font-weight: bold; */
  position: absolute;
  top: 0.71rem;
  left: 1.31rem;
}
.pswd {
  position: absolute;
  top: 1.31rem;
  left: 1.11rem;
}
.pswd_label {
  position: absolute;
  top: 1.31rem;
  left: 1.31rem;
}
input:focus-visible {
  outline: none;
}
.forget {
  /* width: 0.47rem;
  height: 0.1rem; */
  font-size: 0.15rem;
  font-family: "Normal";
  font-weight: 400;
  color: #4b1400;
  line-height: 0.2rem;
  position: absolute;
  bottom: 1.32rem;
  left: 1.23rem;
  cursor: pointer;
}
.code_login {
  /* width: 0.53rem;
  height: 0.1rem; */
  font-size: 0.15rem;
  font-family: "Normal";
  font-weight: 400;
  color: #4b1400;
  line-height: 0.2rem;
  position: absolute;
  bottom: 1.32rem;
  right: 1.4rem;
  cursor: pointer;
}
.mobile {
  position: absolute;
  top: 0.71rem;
  left: 1.11rem;
}
.mobile_label {
  position: absolute;
  top: 0.71rem;
  left: 1.31rem;
}

.code {
  position: absolute;
  top: 1.31rem;
  left: 1.11rem;
}
.code_label {
  position: absolute;
  top: 1.31rem;
  left: 1.31rem;
}
.get_code_label {
  position: absolute;
  top: 1.4rem;
  right: 1.31rem;
  width: 0.65rem;
  height: 0.23rem;
  background: #69a0ca;
  text-align: center;
  line-height: 0.23rem;
  color: #fff;
  cursor: pointer;
  border-radius: 0.05rem;
}
.get_code_label span {
  font-size: 0.1rem;
  font-family: "Normal";
}
.newpswd {
  position: absolute;
  top: 1.89rem;
  left: 1.11rem;
}
.newpswd_label {
  position: absolute;
  top: 1.89rem;
  left: 1.31rem;
}
.confirgpswd {
  position: absolute;
  top: 2.48rem;
  left: 1.11rem;
  box-sizing: border-box;
  padding-left: 1rem !important;
}
.confirgpswd_label {
  position: absolute;
  top: 2.48rem;
  left: 1.31rem;
}
.label {
  font-size: 0.17rem;
  font-family: "Normal";
  color: #ffffff;
  z-index: 2;
  height: 0.4rem;
  line-height: 0.4rem;
}
.register_bgc {
  width: 5.2rem;
  height: 4.33rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: url("../assets/images/login_bgc.png") no-repeat;
  background-size: 100% 100%;
}
.register_name {
  position: absolute;
  top: 0.71rem;
  left: 1.18rem;
}
.register_name_label {
  position: absolute;
  top: 0.71rem;
  left: 1.4rem;
}
.register_school {
  position: absolute;
  top: 1.27rem;
  left: 1.18rem;
}
.register_school_label {
  position: absolute;
  top: 1.27rem;
  left: 1.4rem;
}
.register_grade {
  position: absolute;
  top: 1.8rem;
  left: 1.18rem;
}
.register_grade_label {
  position: absolute;
  top: 1.8rem;
  left: 1.4rem;
}
.register_mobile {
  position: absolute;
  top: 2.33rem;
  left: 1.18rem;
}
.register_mobile_label {
  position: absolute;
  top: 2.33rem;
  left: 1.4rem;
}
.register_code {
  position: absolute;
  top: 2.86rem;
  left: 1.18rem;
}
.register_code_label {
  position: absolute;
  top: 2.86rem;
  left: 1.4rem;
}
.register_get_code_label {
  position: absolute;
  top: 2.95rem;
  right: 1.21rem;
  width: 0.65rem;
  height: 0.23rem;
  background: #66a1d1;
  text-align: center;
  line-height: 0.23rem;
  color: #fff;
  cursor: pointer;
  border-radius: 0.05rem;
}
.register_get_code_label span {
  font-size: 0.1rem;
  font-family: "Normal";
}
.register_pswd {
  position: absolute;
  top: 3.39rem;
  left: 1.18rem;
}
.register_pswd_label {
  position: absolute;
  top: 3.39rem;
  left: 1.4rem;
}
.tijiao_btn {
  width: 1.36rem;
  height: 0.41rem;
  position: absolute;
  bottom: -0.09rem;
  left: 50%;
  transform: translate(-50%, 0);
  cursor: pointer;
}
input::placeholder {
  color: #a45a12;
  line-height: 0.4rem;
}
.birthday {
  position: absolute;
  top: 1.75rem;
  left: 1.14rem;
}
.birthday_label {
  position: absolute;
  top: 1.75rem;
  left: 1.33rem;
}
.gender {
  position: absolute;
  top: 2.35rem;
  left: 1.14rem;
}
.gender_label {
  position: absolute;
  top: 2.35rem;
  left: 1.33rem;
}
.header_box {
  width: 0.82rem;
  height: 0.82rem;
  position: absolute;
  top: 0.71rem;
  left: 50%;
  transform: translate(-50%, 0);
}
.header_box .header {
  display: block;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: url("../assets/images/header_bgc.png") no-repeat;
  background-size: 100% 100%;
}
.header_img {
  width: 0.74rem;
  height: 0.74rem;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.upload {
  width: 0.33rem;
  height: 0.33rem;
  position: relative;
  bottom: 0.55rem;
  left: 50%;
  transform: translate(-50%, 0);
}
.shade {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
}
.header_list {
  width: 100%;
  height: 1.46rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.3);
  box-sizing: border-box;
  padding: 0.33rem 0.59rem 0.23rem 0.63rem;
}
ul {
  width: auto;
  height: 104%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
ul li {
  display: inline-block;
}
.system_box {
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 0.05rem;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
  display: inline-block;
  margin-right: 0.23rem;
}
.system_header {
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 0.05rem;
  box-sizing: border-box;
  border: 0.03rem solid transparent;
}
.select_show {
  border: 0.03rem solid #ffe400;
}
.selecet_header {
  width: 0.23rem;
  height: 0.23rem;
  position: absolute;
  bottom: 0;
  right: 0;
}
.queding {
  width: 0.72rem;
  height: 0.24rem;
  position: absolute;
  bottom: -0.4rem;
  left: 50%;
  transform: translate(-50%, 0);
  cursor: pointer;
}
::v-deep .el-date-editor.el-input,
::v-deep .el-date-editor.el-input__inner {
  position: absolute;
  top: 1.75rem;
  left: 2rem;
  width: 2rem;
}
::v-deep .el-input__inner {
  background-color: #bf6004;
  border: none;
  color: #fff;
  font-size: 0.16rem;
  font-family: "Normal";
  height: 0.4rem;
  border-radius: 0.2rem;
}
::v-deep .el-input__icon {
  line-height: 0.4rem;
}
</style>